import { epochDateTime } from '@hotjar/webapp/lib/time';
import type { RawUserAttribute, UserAttribute } from '../types';
import { DataTypeEnum } from '../types';

/**
 * Constructs the User Attributes object by standardizing the format of attributes and user ID.
 */
export function constructUserAttributes(
  rawUserAttributes: RawUserAttribute[],
  userId?: number,
): UserAttribute[] {
  let userAttributes = <UserAttribute[]>[];

  if (rawUserAttributes) {
    userAttributes = rawUserAttributes
      .map((userAttribute) => {
        const { datatype, name } = userAttribute;

        let value = userAttribute[`${datatype}_value`];
        if (datatype === DataTypeEnum.DATE && value !== null) {
          value = epochDateTime(Number(value));
        } else if (datatype === DataTypeEnum.BOOLEAN && value !== null) {
          value = value ? 'true' : 'false';
        }

        return { datatype, name, value };
      })
      .sort((first, second) => {
        if (first.name === DataTypeEnum.EMAIL) return -1;
        if (second.name === DataTypeEnum.EMAIL) return 1;

        return first.name.localeCompare(second.name);
      });
  }

  // If there's a User ID, push it to the front of it list.
  if (userId) {
    userAttributes.unshift({
      datatype: DataTypeEnum.STRING,
      name: 'user_id',
      value: userId,
    });
  }

  return userAttributes;
}
